<template lang="pug">
.new-filters-modal
	.new-filters-container
		modal.new-filters(
			:state='state'
			@close='close'
		)
			.filter-content.modal-box(slot='content')
				.title-container
					p Set New Filters
					.icon-close(@click='close')
				.body(v-if='state === "opened"')
					.filter(
						v-for='filter in sortedFilters'
					)
						p.label {{ filter.title }}
						custom-dropdown(
							v-if='filter.filter === "dropdown"'
							:options='config.dropdownOptions[filter.key]'
							:value='""'
							@text='addValue( $event, filter )'
						)
						short-text-input.icon-search(
							v-else-if='filter.filter === "string"'
							:options='{ placeholder : "Search" }'
							:value='""'
							@input='addValue( $event, filter )'
						)
						date-filter(
							v-else-if='filter.filter === "date"'
							@filter='addValue( $event, filter )'
							:show-text='true'
						)
						boolean-filter(
							v-else-if='filter.filter === "boolean"'
							@filter='addValue( $event, filter )'
						)
				a.download.button(@click='download') Download
</template>

<script>
import Vue from 'vue';

import Modal from '@/components/Modal';
import DropdownFilter from '@/components/DropdownFilter';
import ShortTextInput from '@/components/form-inputs/ShortTextInput';
import CustomDropdown from '@/components/form-inputs/CustomDropdown';
import DateFilter from '@/components/DateFilter';
import BooleanFilter from '@/components/BooleanFilter';

export default {
	name : 'new-filters-modal',

	props : {
		state : {
			type : String
		},
		config : {
			type : Object,
		},
	},

	data : () => ( {
		filters : {},
	} ),

	computed : {
		columns() {
			return this.config.columns;
		},

		sortedFilters() {
			const { columns } = this.config;

			if ( !columns || !Object.keys( columns ).length ) {
				return [];
			}

			const filters = Object.keys( columns ).map( ( key ) => {
				const column = columns[key];

				const { filter, title, filterColumn } = column;

				return {
					filter,
					title,
					filterColumn,
					key
				};

			} );

			return filters.sort( ( a, b ) => a.filter.localeCompare( b.filter ) );
		},
	},

	methods : {
		close() {
			this.$emit( 'close' );
			this.filters = {};
		},

		addValue( val, filter ) {
			const filterKey = filter.filterColumn || filter.key;
			Vue.set( this.filters, filterKey, val );
		},

		download() {
			this.$emit( 'download', this.filters );
			this.close();
		},
	},

	components : {
		Modal,
		DropdownFilter,
		ShortTextInput,
		CustomDropdown,
		DateFilter,
		BooleanFilter,
	},
};
</script>

<style lang="scss">
.new-filters-modal {
	.new-filters-container {
		position: relative;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;

		.new-filters {
			z-index: 9999;
			top: 0%;
			left: 0%;
			width: 100%;
			overflow: hidden;
			height: 100%;
			position: fixed;
			background: rgba( $color-primary, .6 );

			.modal-content {
				position: relative;
				top: 0;
				left: 0%;
				transform: translate( 0%, 0% );
				display: flex;
				flex-flow: row;
				align-items: center;
				justify-content: center;
				width: 100%;
				height: 100%;
				padding: 30px 0;
				overflow-y: auto;

				.filter-content {
					width: 400px;
					display: flex;
					flex-flow: column;
					position: relative;
					top: 0%;
					left: 0%;
					transform: translate( 0%, 0% );
					margin: auto;
					height: auto;
					max-width: 700px;
					overflow: hidden;

					.title-container {
						display: flex;
						flex-flow: row;
						justify-content: space-between;
						padding: 15px 21px 15px;
						margin-bottom: 20px;
						margin-top: 6px;

						p {
							color: $color-primary;
						}

						.icon-close {
							height: 20px;
							width: 20px;
						}
					}

					.body {
						overflow-x: hidden;
					}

					.filter {
						width: 100%;
						padding: 10px 0px 10px 21px;
						display: flex;
						flex-flow: row nowrap;
						justify-content: space-between;
						align-items: center;
						height: 47px;

						.label {
							color: $input-color;
							font-size: 14px;
							margin: 0;
							font-weight: 500;
							white-space: nowrap;
						}

						.dropdown {
							width: 100%;
							font-size: 12px;
							background: none;
							box-shadow: none;

							.select-display {

								p {
									padding-right: 30px;
									color: $input-color-faded;
									text-align: right;
								}
							}
						}

						.date-filter {
							margin-right: 18px;
							max-width: 55%;
							position: relative;

							&.open {
								z-index: 10;
							}

							.date-dropdown {
								right: 0;
								left: unset;
								transform: translateX(10px);

								.arrow {
									left: 100%;
									transform: translate(-50px,-100%);
								}
							}
						}

						.short-text {
							box-shadow: none;
							position: relative;
							width: 100%;
							padding: 0 20px!important;
							font-size: 12px;

							&::before {
								position: absolute;
								color: $input-color;
								right: 0;
								padding-right: 21px;
							}

							input {
								text-align: right;
								padding-right: 24px;
								color: $input-color-faded;

								&::placeholder {
									color: $input-color-faded;
								}
							}
						}
					}

					.download {
						margin: auto;
						margin-top: 5px;
						margin-bottom: 20px;
					}

				}
			}
		}
	}
}
</style>
